export default [
    {
        name: "Constable FRH",
        birth: 2018,
        height: "1.7m",
        movies: [
          "https://youtu.be/HsfiGMRLIKA?feature=shared",
          "https://youtu.be/Gx2Baoev2_k?feature=shared",
          "https://youtu.be/61m1Eslgbo8?feature=shared",
          "https://www.instagram.com/reel/DP9UFi3DD2t",
          "https://www.instagram.com/reel/DP6Mh6_DCYi",
          "https://youtu.be/g1tc5-hwIYQ?si=EkqV5zpEHHJytlQ4",
          "https://youtu.be/0H_3E1YnHg0?si=pJgjZQLag_qKE32",
          "https://youtu.be/AeX_Cpka6-Q?si=2L2j9zRAfe5Y0E7Z",
          "https://www.facebook.com/watch/?v=1884934378566770",
          "https://youtu.be/pcCAlUTmD0o?si=RyRTBvagApOmToWS",
          "https://youtu.be/-9wIB2GmHls?si=cZDVpX-psTqS90aE",
          "https://www.facebook.com/EquiClubZamlyniec/videos/1879391545541232"
        ],
        pictures: [
          "CONSTABLE_11.jpg",
          "CONSTABLE_12.jpg",
          "CONSTABLE_13.jpg",
          "CONSTABLE_14.jpg",
          "CONSTABLE_15.jpg",
          "CONSTABLE_16.jpg",
          "CONSTABLE_17.jpg",
          "CONSTABLE_18.jpg",
          "CONSTABLE_19.jpg",
          "CONSTABLE_20.jpg",
          "CONSTABLE_1.jpg",
          "CONSTABLE_2.jpg",
          "CONSTABLE_3.jpg",
          "CONSTABLE_4.jpg",
          "CONSTABLE_5.jpg",
          "CONSTABLE_6.jpg",
          "CONSTABLE_7.jpg",
          "CONSTABLE_8.jpg",
          "CONSTABLE_9.jpg",
          "CONSTABLE_10.jpg"
        ],
        cover: "CONSTABLE_3.jpg",
        thumb: "CONSTABLE_thumb.jpg",
        sex: "Stallion",
        tree: "Constable_tree.svg",
        slug: "constable-frh",
        sport: "1.40m sj",
        tableConfig: [
          { rows: 1 },
          { rows: 1 }
        ]
      },
      {
        name: "Chaccolatte",
        birth: 2020,
        height: "-",
        movies: [
          "https://youtu.be/8OauHwCtoXY?feature=shared",
          "https://www.instagram.com/reel/CmBtW6TNj99/?igsh=N2o4cHBoZXg4ZWE0",
          "https://www.instagram.com/reel/CmHeru2JqAh/?igsh=MXBzOTFsMDRlZndxZQ==",
          "https://www.instagram.com/tv/CgPCbQolpzy/?igsh=Z3Nxam80NnI0bGsz"
        ],
        pictures: [
          "CHACCOLATTE_14.jpg",
          "CHACCOLATTE_5.jpg",
          "CHACCOLATTE_6.jpg",
          "CHACCOLATTE_7.jpg",
          "CHACCOLATTE_8.jpg",
          "CHACCOLATTE_9.jpg",
          "CHACCOLATTE_10.jpg",
          "CHACCOLATTE_11.jpg",
          "CHACCOLATTE_12.jpg",
          "CHACCOLATTE_0.jpg",
          "CHACCOLATTE_1.jpg",
          "CHACCOLATTE_3.jpg",
          "CHACCOLATTE_4.jpg",
        ],
        cover: "CHACCOLATTE_5.jpg",
        thumb: "CHACCOLATTE_thumb.jpg",
        sex: "Mare",
        tree: "Chaccolatte_tree.svg",
        slug: "chaccolatte",
        sport: "-",
      },
      {
        name: "Kookie",
        birth: 2018,
        height: "-",
        movies: [],
        pictures: ["KOOKIE_4.jpg", "KOOKIE_5.jpg", "KOOKIE_0.jpg", "KOOKIE_1.jpg", "KOOKIE_2.jpg", "KOOKIE_3.jpg"],
        cover: "KOOKIE_0.jpg",
        thumb: "KOOKIE_thumb.jpg",
        sex: "Mare",
        tree: "Kookie_tree.svg",
        slug: "kookie",
        sport: "-",
      },
].map((horse) => ({
    ...horse,
    filter: 'sport'
}))
